import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgBagIcon = function SvgBagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.359 37.78 1.104-21.743 4.013-.03v3.642h2.755v-3.636l7.609.018v3.618h2.754v-3.612l3.941-.024 1.237 21.766zm7.845-25.194c0-2.11 1.67-3.826 3.721-3.826h.152c2.052 0 3.721 1.716 3.721 3.826v1.206l-7.594-.016zm16.537 2.216a1.06 1.06 0 0 0-1.05-.991l-5.21-.012v-1.213c0-1.759-.666-3.413-1.875-4.656A6.28 6.28 0 0 0 24.077 6h-.152c-1.71 0-3.318.686-4.528 1.93a6.63 6.63 0 0 0-1.875 4.656v1.183l-5.13-.012a1.07 1.07 0 0 0-1.053.994l-1.333 24.257c-.03.55.386.995.945.992l26.096-.134a.946.946 0 0 0 .949-.995z"
  })));
};

export { SvgBagIcon as default };
